<template>
  <div class="bsg-app">
    <aside class="bsg-sidebar">
      <router-link class="bsg-logo" to="/xingzheng/dashboard">
        <span class="bsg-logo-mark">贝</span>
        <span class="bsg-logo-text">
          <b>BSG</b>
          <small>行政管理系统</small>
        </span>
      </router-link>

      <nav class="bsg-nav">
        <div class="bsg-nav-section">主菜单</div>
        <router-link
          v-for="item in mainMenus"
          :key="item.path"
          :to="item.path"
          class="bsg-nav-item"
          :class="{ active: isActive(item) }"
        >
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </router-link>

        <div class="bsg-nav-section">事业群</div>
        <router-link
          v-for="item in groupMenus"
          :key="item.path"
          :to="item.path"
          class="bsg-nav-item"
          :class="{ active: isActive(item) }"
        >
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </router-link>
      </nav>

      <button class="bsg-sidebar-user" type="button">
        <span class="bsg-user-avatar">
          <img v-if="sidebarUser.avatar" :src="sidebarUser.avatar" alt="" @error="onAvatarError" />
          <span v-else>{{ sidebarUser.initial }}</span>
        </span>
        <span class="bsg-user-meta">
          <b>{{ sidebarUser.name }}</b>
          <small>{{ sidebarUser.roleLabel }} ▾</small>
        </span>
      </button>
    </aside>

    <main class="bsg-main">
      <router-layout />
    </main>
  </div>
</template>

<script>
  import RouterLayout from '@/components/RouterLayout/index.vue';

  export default {
    name: 'EleLayout',
    components: {
      RouterLayout
    },
    mounted() {
      this.hadBodyLimitWidth = document.body.classList.contains('ele-body-limit-width');
      document.body.classList.add('bsg-body');
      document.body.classList.remove('ele-body-limit-width');
    },
    beforeDestroy() {
      document.body.classList.remove('bsg-body');
      if (this.hadBodyLimitWidth) {
        document.body.classList.add('ele-body-limit-width');
      }
    },
    data() {
      return {
        hadBodyLimitWidth: false,
        avatarLoadFailed: false,
        mainMenus: [
          { title: '数据看板', path: '/xingzheng/dashboard', icon: 'el-icon-house' },
          { title: '员工管理', path: '/xingzheng/employees', icon: 'el-icon-user' },
          { title: '周年纪念', path: '/xingzheng/anniversary', icon: 'el-icon-medal' },
          { title: '生日管理', path: '/xingzheng/birthday', icon: 'el-icon-present' },
          { title: '离职管理', path: '/xingzheng/attrition', icon: 'el-icon-switch-button' }
        ],
        groupMenus: [
          { title: 'BSG 大事记', path: '/xingzheng/events', icon: 'el-icon-s-flag' },
          { title: 'BSG 照片集', path: '/xingzheng/album', icon: 'el-icon-picture-outline' },
          { title: '安全检查', path: '/xingzheng/safety', icon: 'el-icon-warning-outline' },
          { title: '出差记录', path: '/xingzheng/travel', icon: 'el-icon-position' }
        ]
      };
    },
    computed: {
      loginUser() {
        return this.$store.state.user.info || {};
      },
      sidebarUser() {
        const name = this.firstText([
          this.loginUser.nickname,
          this.loginUser.name,
          this.loginUser.real_name,
          this.loginUser.username,
          this.loginUser.account
        ]) || '管理员';
        const avatar = this.avatarLoadFailed
          ? ''
          : this.firstText([
              this.loginUser.avatar,
              this.loginUser.avatar_url,
              this.loginUser.headimgurl,
              this.loginUser.head_img
            ]);
        return {
          name,
          avatar,
          initial: name.slice(0, 1),
          roleLabel: this.firstText([
            this.loginUser.role_name,
            this.loginUser.roleName,
            this.loginUser.title
          ]) || '行政管理员'
        };
      }
    },
    watch: {
      loginUser() {
        this.avatarLoadFailed = false;
      }
    },
    methods: {
      firstText(values) {
        const value = values.find((item) => item !== undefined && item !== null && `${item}`.trim() !== '');
        return value === undefined ? '' : `${value}`.trim();
      },
      onAvatarError() {
        this.avatarLoadFailed = true;
      },
      isActive(item) {
        if (item.path === '/xingzheng/events') {
          return this.$route.path === item.path;
        }
        if (item.path === '/xingzheng/album') {
          return this.$route.path === item.path;
        }
        return this.$route.path === item.path;
      }
    }
  };
</script>

<style lang="scss">
  body.bsg-body {
    height: 100vh;
    min-width: 0 !important;
    overflow: hidden;
  }

  body.bsg-body #app {
    height: 100vh;
    overflow: hidden;
  }
</style>

<style scoped lang="scss">
  .bsg-app {
    --brand: #df573d;
    --brand-soft: rgba(223, 87, 61, 0.08);
    --ink: #2d2726;
    --ink-2: #615854;
    --ink-3: #8f8785;
    --ink-4: #a48b7d;
    --bg: #fcfbf8;
    --card: #fff;
    --border: rgba(45, 39, 38, 0.08);
    --border-strong: rgba(45, 39, 38, 0.16);
    --radius-md: 12px;
    --shadow-brand: 0 10px 15px -3px rgba(223, 87, 61, 0.25),
      0 4px 6px -4px rgba(223, 87, 61, 0.25);

    display: flex;
    width: 100%;
    height: 100vh;
    min-height: 0;
    overflow: hidden;
    background: var(--bg);
    color: var(--ink);
    font-family: "PingFang SC", "Noto Sans SC", -apple-system, BlinkMacSystemFont,
      "Segoe UI", sans-serif;
  }

  .bsg-app,
  .bsg-app * {
    box-sizing: border-box;
  }

  .bsg-sidebar {
    width: 220px;
    height: 100vh;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 20px 14px;
    border-right: 1px solid var(--border);
    background: var(--card);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .bsg-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px 24px;
    color: inherit;
    text-decoration: none;
  }

  .bsg-logo-mark {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--brand);
    box-shadow: var(--shadow-brand);
    color: #fff;
    font-family: Georgia, "Songti SC", serif;
    font-size: 18px;
    font-weight: 900;
  }

  .bsg-logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1.1;

    b {
      font-family: Georgia, "Songti SC", serif;
      font-size: 16px;
      letter-spacing: 0.5px;
    }

    small {
      margin-top: 2px;
      color: var(--ink-3);
      font-size: 11px;
    }
  }

  .bsg-nav {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bsg-nav-section {
    margin: 8px 0 4px;
    padding: 0 12px;
    color: var(--ink-4);
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .bsg-nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: var(--radius-md);
    color: var(--ink-2);
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    transition: background-color 0.15s, color 0.15s;

    i {
      width: 18px;
      font-size: 16px;
      text-align: center;
      opacity: 0.85;
    }

    &:hover {
      background: #f5f1ed;
    }

    &.active {
      background: var(--brand-soft);
      color: var(--brand);
      font-weight: 700;
    }
  }

  .bsg-sidebar-user {
    margin-top: auto;
    padding: 12px;
    border: 0;
    border-top: 1px solid var(--border);
    background: transparent;
    display: flex;
    align-items: center;
    gap: 10px;
    color: inherit;
    text-align: left;
    cursor: pointer;
  }

  .bsg-user-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: linear-gradient(135deg, #df573d, #a48b7d);
    color: #fff;
    font-size: 13px;
    font-weight: 700;

    img {
      width: 100%;
      height: 100%;
      border-radius: inherit;
      object-fit: cover;
      display: block;
    }
  }

  .bsg-user-meta {
    line-height: 1.1;

    b {
      display: block;
      color: var(--ink);
      font-size: 13px;
    }

    small {
      color: var(--ink-3);
      font-size: 11px;
    }
  }

  .bsg-main {
    min-width: 0;
    height: 100vh;
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  @media (max-width: 860px) {
    .bsg-sidebar {
      width: 184px;
      padding: 16px 10px;
    }
  }
</style>
